import { Nullable } from "../types/common";

export default function debounce<F extends (...params: any[]) => void>(fn: F, delay: number) {
  let timeoutID: Nullable<number> = null;
  return function (this: any, ...args: any[]) {
    // @ts-ignore
    clearTimeout(timeoutID);
    timeoutID = window.setTimeout(() => fn.apply(this, args), delay);
  } as F;
}
